function getPostHandler() {
  return window.postMessage
}

const postHandler = getPostHandler()

type AppCrashedPayload = {
  url: string
}

type TransactionSentPayload = {
  transactionId: string
}

type EventQuitButton = undefined

export type AppEventsList = {
  "app-crashed": AppCrashedPayload
  "transaction-sent": TransactionSentPayload
  quit: EventQuitButton
}

type AppEvent<K extends keyof AppEventsList> = {
  eventName: K
  payload?: AppEventsList[K]
}

export function sendCustomEvent<K extends keyof AppEventsList>(
  event: AppEvent<K>,
) {
  postHandler({
    event: event.eventName,
    payload: event.payload,
  })
}

sendCustomEvent({
  eventName: "quit",
})

sendCustomEvent({
  eventName: "app-crashed",
  payload: {
    url: "https://",
  },
})

sendCustomEvent({
  eventName: "transaction-sent",
  payload: {
    transactionId: "12345",
  },
})

sendCustomEvent({
  eventName: "transaction-sent",
  payload: {
    transactionId: "https://",
  },
})

sendCustomEvent({
  eventName: "app-crashed",
  payload: {
    url: "123",
  },
})

sendCustomEvent({
  eventName: "app-crashed",
  payload: {
    url: "123",
  },
})
